function fillDropdown(dropdown, options, value, dropdownChanged) {
  const placeholder = dropdown.getAttribute('placeholder')
  dropdown.innerHTML = ''

  if (dropdownChanged !== true && placeholder !== undefined) {
    const placeholderOption = document.createElement('option')
    placeholderOption.hidden = true
    placeholderOption.textContent = placeholder
    dropdown.appendChild(placeholderOption)
  }

  options.forEach(function (e) {
    const option = document.createElement('option')
    option.value = e.value
    option.textContent = e.name
    option.selected = (e.value == value)
    dropdown.appendChild(option)
  })
}

export default function DropdownTerminFooter(terminFooterMapping) {

  if (!document.querySelector('.form')) {
    return;
  }
  if (typeof terminFooterMapping === 'undefined') {
    return;
  }

  /**
   * GLOBAL VARIABLES
   */
  const fachgebietSelect = document.querySelector('.form .dropdown--expertise select')
  const standortSelect = document.querySelector('.form .dropdown--location select')
  let defaultFachgebiet = fachgebietSelect.dataset.defaultvalue
  let defaultStandort = standortSelect.dataset.defaultvalue
  let fachgebietChanged = false
  let standortChanged = false
  let chosenStandort = 0
  let chosenFachgebiet = 0

  /**
   * ON CHANGE HANDLERS
   */
  fachgebietSelect.addEventListener('change', function () {
    fachgebietChanged = true
    chosenFachgebiet = this.value

    if (chosenFachgebiet !== 0) {
      const mapping = terminFooterMapping['mapping']['fachgebiete'][chosenFachgebiet]
      const tmpOptions = terminFooterMapping['standorte'].filter(option => mapping.includes(option.value))
      fillDropdown(fachgebietSelect, terminFooterMapping['fachgebiete'], chosenFachgebiet, fachgebietChanged)
      fillDropdown(standortSelect, tmpOptions, (chosenStandort !== 0 ? chosenStandort : defaultStandort), standortChanged)
    } else {
      fillDropdown(standortSelect, terminFooterMapping['standorte'], defaultStandort, standortChanged)
    }
  })

  standortSelect.addEventListener('change', function () {
    chosenStandort = this.value
    standortChanged = true

    if (chosenStandort !== 0) {
      const mapping = terminFooterMapping['mapping']['standorte'][chosenStandort]
      const tmpOptions = terminFooterMapping['fachgebiete'].filter(option => mapping.includes(option.value))
      fillDropdown(standortSelect, terminFooterMapping['standorte'], chosenStandort, standortChanged)
      fillDropdown(fachgebietSelect, tmpOptions, (chosenFachgebiet !== 0 ? chosenFachgebiet : defaultFachgebiet), fachgebietChanged)
    } else {
      fillDropdown(fachgebietSelect, terminFooterMapping['fachgebiete'], defaultFachgebiet, fachgebietChanged)
    }
  })

  /**
   * INIT
   */
  // set chosen values as default variables
  if (fachgebietSelect.value !== '' && !isNaN(parseInt(fachgebietSelect.value))) {
    defaultFachgebiet = fachgebietSelect.value
  }
  if (standortSelect.value !== '' && !isNaN(parseInt(standortSelect.value))) {
    defaultStandort = standortSelect.value
  }

  // fill dropdowns
  fillDropdown(fachgebietSelect, terminFooterMapping['fachgebiete'], defaultFachgebiet, fachgebietChanged)
  fillDropdown(standortSelect, terminFooterMapping['standorte'], defaultStandort, fachgebietChanged)

  // if select values are already set - fire change handlers to adjust the dropdown of another select
  if (defaultStandort !== '' && !isNaN(defaultStandort)) {
    standortSelect.value = defaultStandort
    standortSelect.dispatchEvent(new Event('change'))
  } else if (defaultFachgebiet !== '' && !isNaN(defaultFachgebiet)) {
    fachgebietSelect.value = defaultFachgebiet
    fachgebietSelect.dispatchEvent(new Event('change'))
  }

  // set defaults after init to undefined in order for on change handlers to work correctly
  defaultFachgebiet = undefined
  defaultStandort = undefined
}
